<template>

  <div>
    <date-picker 
      ref="date"
      :value="value"
      @input="change"
      :lang="lang"
      :placeholder="placeholder"
      :width="width || '100%'"
      :popupStyle="popupStyle || {left: 0}"
      type="month"
      format="MM/YYYY"
      @panel-change="handlePanelChange">
      </date-picker>
  </div>
  
</template>

<script>
import DatePicker from 'vue2-datepicker'

export default {
  name: 'Date',
  components: {
    DatePicker
  },
  props: [
    'value',
    'placeholder',
    'width',
    'popupStyle',
    'initialSelect'
  ],
  data () {
    return {
      lang: 'pt-br'
    }
  },
  methods: {
    change (value) {
      this.$emit('input', value)
    },
    handlePanelChange (panel, oldPanel) {
      if (this.initialSelect === 'year' && oldPanel === 'NONE') {
        this.$refs.date.$children[0].panel = 'YEAR'
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/InputMonth.vue